export const NAVBAR_BLOCK_s7 = {
  "blockType": "NAVBAR",
  "blockDesign": "NavDesign1",
  "editFormName": "NAVBAR_FORM_1",
  "styleProps": {
    "background-color": "#ffffff"
  },
  "logoType": "text",
  "logoImg": {
    "src": "https://freshflowxyz.b-cdn.net/assets/logo/FlexBee-Logo-1.jpg",
    "altText": "FlexBee",
    "styleProps": {
      "height": "3rem"
    }
  },
  "logoText": {
    "text": "Nodic",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#333333",
      "font-family": "'Lato', sans-serif",
      "line-height": "2.25rem",
      "font-family-bk": "'Lato', sans-serif",
      "font-weight": "900"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "logoHTML": {
    "html": "FlexBee",
    "styleProps": {
      "font-size": "1.875rem",
      "color": "#ffffff",
      "font-family": "'Oswald', sans-serif",
      "line-height": "2.25rem"
    },
    "stylePropsMob": {},
    "stylePropsTab": {}
  },
  "links": [
    {
      "text": "Features",
      "linkUrl": "/features",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Services",
      "linkUrl": "/services",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Docs",
      "linkUrl": "/docs",
      "styleProps": {
        "color": ""
      },
      "sectionID": "aboutsection"
    },
    {
      "text": "Blog",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "",
        "margin": "0px 0px 0px 120px"
      }
    },
    {
      "text": "Get Started",
      "linkUrl": "/home",
      "sectionID": "aboutsection",
      "styleProps": {
        "color": "#333333",
        "border-width": "0px",
        "border-radius": "9999px",
        "padding": "14px 30px 14px 30px",
        "margin": "0px 0px 0px 20px",
        "border-color": "#4f4f4f",
        "background-color": "#BFC8EB"
      }
    }
  ],
  "hamburgerStyleProps": {
    "color": "#333333",
    "border-color": "#333333"
  },
  "metaDataId": 1746277421219,
  "afterIndex": 3,
  "blockId": 1746277421219,
  "linksStyleProps": {
    "color": "#333333",
    "padding": "14px 0px 14px 0px",
    "font-weight": "600",
    "font-size": "1.125rem",
    "line-height": "1.75rem"
  }
}